var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ImageData = /** @class */ (function () {
    function ImageData() {
        this.minScale = 1;
    }
    ImageData.create = function (src, desiredSize, crop) {
        return __awaiter(this, void 0, void 0, function () {
            var img, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        img = new ImageData();
                        _a = img;
                        return [4 /*yield*/, getNaturalSize(src)];
                    case 1:
                        _a.naturalSize = _b.sent();
                        img.aspect = img.naturalSize.width / img.naturalSize.height;
                        img.baseSize = {
                            width: img.aspect <= 1 ? desiredSize.width : desiredSize.height * img.aspect,
                            height: img.aspect >= 1 ? desiredSize.height : desiredSize.width * (1 / img.aspect)
                        };
                        img.maxScale = Math.min(img.naturalSize.width / desiredSize.width, img.naturalSize.height / desiredSize.height);
                        img.initialScale = img.guardScale(getScale(desiredSize, crop));
                        img.cropCenter = getCenterPercentage(crop);
                        return [2 /*return*/, img];
                }
            });
        });
    };
    ImageData.prototype.scale = function (scale) {
        return {
            width: this.baseSize.width * scale,
            height: this.baseSize.height * scale
        };
    };
    ImageData.prototype.getCrop = function (desiredSize, offset, scale) {
        var size = this.scale(scale);
        var topLeft = getPointPercentage({ x: 0, y: 0 }, offset, size);
        var bottomRight = getPointPercentage({ x: desiredSize.width, y: desiredSize.height }, offset, size);
        return {
            x1: topLeft.x,
            y1: topLeft.y,
            x2: 1 - bottomRight.x,
            y2: 1 - bottomRight.y
        };
    };
    ImageData.prototype.center = function (location, desiredSize, scale) {
        var size = this.scale(scale);
        return this.guardOffset({
            x: -((size.width * location.x) - (desiredSize.width / 2)),
            y: -((size.height * location.y) - (desiredSize.height / 2))
        }, desiredSize, scale);
    };
    ImageData.prototype.guardOffset = function (offset, desiredSize, scale) {
        var size = this.scale(scale);
        return {
            x: Math.min(Math.max(offset.x, desiredSize.width - size.width), 0),
            y: Math.min(Math.max(offset.y, desiredSize.height - size.height), 0)
        };
    };
    ImageData.prototype.guardScale = function (scale) {
        return Math.max(Math.min(scale, this.maxScale), this.minScale);
    };
    return ImageData;
}());
export { ImageData };
export function getNaturalSize(src) {
    return __awaiter(this, void 0, void 0, function () {
        var img;
        return __generator(this, function (_a) {
            img = new Image();
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    img.onload = function () {
                        resolve({
                            width: img.naturalWidth,
                            height: img.naturalHeight
                        });
                    };
                    img.onerror = function (error) {
                        reject(error);
                    };
                    img.src = src;
                })];
        });
    });
}
export function getPointPercentage(location, offset, size) {
    return {
        x: (location.x - offset.x) / size.width,
        y: (location.y - offset.y) / size.height
    };
}
export function getScale(desiredSize, crop) {
    if (!crop)
        return 1;
    return Math.min(desiredSize.width / (((1 - crop.x2) - crop.x1) * desiredSize.width), desiredSize.height / (((1 - crop.y2) - crop.y1) * desiredSize.height));
}
export function getCenterPercentage(crop) {
    if (!crop)
        return { x: 0.5, y: 0.5 };
    return {
        x: (((1 - crop.x2) - crop.x1) / 2) + crop.x1,
        y: (((1 - crop.y2) - crop.y1) / 2) + crop.y1
    };
}
export function isDataUri(src) {
    return !!src.match(/^data:/i);
}
export function addDataUri(src) {
    return "data:image/jpeg;base64," + src;
}
export function stripDataUri(src) {
    return src.replace(/^data:.*;base64,/i, "");
}
export function getCropUrl(src, crop, size) {
    if (!src)
        return src;
    src += "?crop=" + crop.x1 * 100 + "," + crop.y1 * 100 + "," + crop.x2 * 100 + "," + crop.y2 * 100 + "&cropmode=percentage";
    if (size) {
        src += "&width=" + size.width + "&height=" + size.height;
    }
    return src;
}
export function parseImageCropDataSet(value) {
    if (!value)
        return undefined;
    if (typeof value === "string") {
        return {
            src: value,
            focalPoint: {
                left: 0.5,
                top: 0.5
            },
            crops: []
        };
    }
    return value;
}



//////////////////
// WEBPACK FOOTER
// ./src/Helpers/Image.ts
// module id = 55
// module chunks = 24